import { Typography } from "@/components/text";
import { formatHumanReadableDate } from "@/libraries/date";
import type { CaseTeam, Group } from "@/types";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import type React from "react";
import { useMemo } from "react";

interface TeamCardProps {
	data: CaseTeam | Group;
	profileId?: number;
}

const TeamCard: React.FC<TeamCardProps> = (props) => {
	const { data } = props;
	const teamMembers = useMemo(
		() => (data.type === "team" ? data.users : data.members),
		[data],
	);

	return (
		<Card variant="outlined" className="!w-full !h-full !rounded-xl">
			<div className="flex justify-between items-center p-4 h-full">
				<Stack justifyContent="start" alignItems="start">
					<Typography fontWeight={500} fontSize={14} className="line-clamp-2">
						{data.name}
					</Typography>
					<Typography fontWeight={500} fontSize={12}>
						{teamMembers.length} team members
					</Typography>
					<Typography fontWeight={400} fontSize={10}>
						{formatHumanReadableDate(data.created_at)}
					</Typography>
				</Stack>
				{teamMembers?.length ? (
					<AvatarGroup spacing="small" total={teamMembers.length}>
						{teamMembers.map((user) => (
							<Avatar
								key={user.id}
								className="!bg-zinc-200 !text-dark"
								alt={user.fullname ?? user.first_name ?? user.last_name ?? "L"}
								src={user.avatar ?? "/broken-image.jpg"}
								sx={{ width: 32, height: 32 }}
							/>
						))}
					</AvatarGroup>
				) : null}
			</div>
		</Card>
	);
};

export default TeamCard;
